var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEnterOtp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66.15,
    y: 183.73,
    width: 156.54,
    height: 198.22,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.68,
    y: 190.96,
    width: 145.47,
    height: 42.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.68,
    y: 197.82,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 111.64,
    y: 197.82,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.07,
    y: 197.37,
    width: 8.26,
    height: 35.52,
    transform: "translate(-34.15 31.01) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 202.5,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.91,
    y: 202.5,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 148.85,
    y: 202.5,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.93,
    y: 201.97,
    width: 8.26,
    height: 30.84,
    transform: "translate(-44.06 33.39) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 196.05,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.35,
    y: 196.05,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.68,
    y: 240.05,
    width: 145.47,
    height: 42.39,
    transform: "translate(288.83 522.49) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 208.88,
    y: 246.92,
    width: 8.26,
    height: 35.52,
    transform: "translate(426.03 529.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.93,
    y: 246.92,
    width: 8.26,
    height: 35.52,
    transform: "translate(346.12 529.36) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 120.49,
    y: 246.47,
    width: 8.26,
    height: 35.52,
    transform: "translate(202.55 545.8) rotate(-170.22)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 198.65,
    y: 251.6,
    width: 8.26,
    height: 30.84,
    transform: "translate(405.55 534.04) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 179.65,
    y: 251.6,
    width: 8.26,
    height: 30.84,
    transform: "translate(367.57 534.04) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.71,
    y: 251.6,
    width: 8.26,
    height: 30.84,
    transform: "translate(271.68 534.04) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 154.63,
    y: 251.07,
    width: 8.26,
    height: 30.84,
    transform: "translate(255.94 561.07) rotate(-167.47)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 191.5,
    y: 245.15,
    width: 4.13,
    height: 37.29,
    transform: "translate(387.13 527.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.35,
    y: 245.15,
    width: 4.13,
    height: 37.29,
    transform: "translate(288.83 527.59) rotate(180)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.68,
    y: 246.92,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.92,
    y: 251.6,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100.91,
    y: 251.6,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 93.2,
    y: 245.15,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.68,
    y: 289.15,
    width: 145.47,
    height: 42.39,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 155.17,
    y: 296.01,
    width: 8.26,
    height: 35.52,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.61,
    y: 295.57,
    width: 8.26,
    height: 35.52,
    transform: "translate(-50.2 39.83) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125.45,
    y: 300.7,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 144.45,
    y: 300.7,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 192.39,
    y: 300.7,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169.47,
    y: 300.17,
    width: 8.26,
    height: 30.84,
    transform: "translate(-64.32 45.17) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 136.73,
    y: 294.25,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.88,
    y: 294.25,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.54,
    y: 295.57,
    width: 8.26,
    height: 35.52,
    transform: "translate(-51.58 23.69) rotate(-9.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.32,
    y: 300.7,
    width: 8.26,
    height: 30.84,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.4,
    y: 300.17,
    width: 8.26,
    height: 30.84,
    transform: "translate(-66.59 24.55) rotate(-12.53)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.81,
    y: 294.25,
    width: 4.13,
    height: 37.29,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M305.28,263.63H393.5A17.32,17.32,0,0,1,410.82,281v68.88H288V281A17.33,17.33,0,0,1,305.28,263.63Z",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,314.69h15.78A10.3,10.3,0,0,1,288,325v57H251.58V325A10.3,10.3,0,0,1,261.88,314.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.88,314.69h.33A10.3,10.3,0,0,1,272.51,325v57H251.58V325A10.3,10.3,0,0,1,261.88,314.69Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.91,
    y: 355.78,
    width: 121.06,
    height: 26.17,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.27,
    y: 331.85,
    width: 137.69,
    height: 27.45,
    rx: 10.47,
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.35,
    y: 331.85,
    width: 35.41,
    height: 27.45,
    rx: 10.47,
    style: {
      fill: "#e0e0e0",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,314.69h15.79A10.29,10.29,0,0,1,420.94,325v57H384.57V325A10.29,10.29,0,0,1,394.86,314.69Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.86,314.69h.34A10.29,10.29,0,0,1,405.49,325v57H384.57V325A10.29,10.29,0,0,1,394.86,314.69Z",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.48,
    cy: 136.4,
    r: 23.55,
    transform: "translate(-19.96 25.22) rotate(-9.22)",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 146.48,
    cy: 136.4,
    r: 20.03,
    transform: "translate(-19.96 25.22) rotate(-9.22)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "145.53 150.14 145.53 136.14 136.26 141.39",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.53,151.14a1,1,0,0,1-1-1V137.85l-7.78,4.41a1,1,0,0,1-1.36-.38,1,1,0,0,1,.37-1.36l9.28-5.25a1,1,0,0,1,1.49.87v14A1,1,0,0,1,145.53,151.14Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277.86,
    y: 106.68,
    width: 150.75,
    height: 133.77,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.63,
    y: 110.35,
    width: 143.01,
    height: 126.51,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.19 110.35 281.63 236.58 281.63 177.27 299.35 110.35 315.19 110.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "327.08 110.35 293.22 236.86 287.82 236.86 321.68 110.35 327.08 110.35",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "424.64 190.18 424.64 210.39 417.79 236.86 412.39 236.86 424.64 190.18",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.1,
    y: 108.08,
    width: 2.41,
    height: 131.61,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.79,
    y: 108.08,
    width: 2.41,
    height: 131.61,
    style: {
      fill: "#e6e6e6"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M401.9,391.23s4.75-10.36-.68-20.58-7-12.62-3.54-14.72,5.05,8.18,5.05,8.18a23.1,23.1,0,0,0,.5-14.46c-2.4-7.39-3.91-19.43-.63-20.72s.63,15,3.49,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.35a137.22,137.22,0,0,0-2.53,23.76s5.63-17.19,9.42-17.69,3.78,5.06.54,9.89-9.49,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6-7.86,20.51-7.86,20.51Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.9,391.23s4.75-10.36-.68-20.58-7-12.62-3.54-14.72,5.05,8.18,5.05,8.18a23.1,23.1,0,0,0,.5-14.46c-2.4-7.39-3.91-19.43-.63-20.72s.63,15,3.49,20.58a48.19,48.19,0,0,0,2.79-12.13c.39-5.94-.22-15.42,2.37-17.85s4.26-.75,1.71,12.35a137.22,137.22,0,0,0-2.53,23.76s5.63-17.19,9.42-17.69,3.78,5.06.54,9.89-9.49,13.48-10.51,17.93c0,0,6.19-12.94,11.75-9s-4.84,11.77-9.48,14.6-7.86,20.51-7.86,20.51Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.65,395.48s-4.63-10.43.92-20.57,7.15-12.52,3.72-14.66-5.15,8.1-5.15,8.1a23.07,23.07,0,0,1-.33-14.46c2.49-7.36,4.15-19.38.88-20.72s-.81,15-3.73,20.53a48.29,48.29,0,0,1-2.65-12.17c-.32-5.94.41-15.41-2.16-17.88s-4.25-.81-1.85,12.33a137.07,137.07,0,0,1,2.24,23.78s-5.43-17.27-9.2-17.82-3.84,5-.66,9.88S397,365.44,398,369.9c0,0-6-13-11.64-9.14s4.7,11.84,9.3,14.74,7.62,20.63,7.62,20.63Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "384.31 388.04 422.52 388.04 419.43 415.39 387.4 415.39 384.31 388.04",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242.6,411v3.59a.81.81,0,0,1-.81.81H140.37a5.29,5.29,0,0,1-4.91-7.26l32.14-79.6,51.94.35-1.77,10.33-11.46,66.85a3.54,3.54,0,0,0,3.48,4.13h32A.8.8,0,0,1,242.6,411Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.6,411v3.59a.81.81,0,0,1-.81.81H140.37a5.29,5.29,0,0,1-4.91-7.26l19.93-49.35,12.21-30.25,51.94.35-1.77,10.33-5,29.07-6.47,37.78a3.54,3.54,0,0,0,3.48,4.13h32A.8.8,0,0,1,242.6,411Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.79,410.19h-66a2.32,2.32,0,0,1-2.14-3.2l28.18-67.78h47.93l-11.46,66.85A3.54,3.54,0,0,0,209.79,410.19Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.54 328.88 217.77 339.21 212.78 368.28 155.39 358.79 167.6 328.53 219.54 328.88",
    style: {
      isolation: "isolate",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,180.5H80.08a6.15,6.15,0,0,0-6.15,6.15V349.44a6.15,6.15,0,0,0,6.15,6.15H320.53a6.16,6.16,0,0,0,6.16-6.15V186.65A6.16,6.16,0,0,0,320.53,180.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.53,180.5H80.08a6.15,6.15,0,0,0-6.15,6.15V349.44a6.15,6.15,0,0,0,6.15,6.15H320.53a6.16,6.16,0,0,0,6.16-6.15V186.65A6.16,6.16,0,0,0,320.53,180.5Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.18,355.58h-5.1a6.15,6.15,0,0,1-6.15-6.14V186.66a6.15,6.15,0,0,1,6.15-6.16h5.1A6.15,6.15,0,0,0,79,186.66V349.44A6.14,6.14,0,0,0,85.18,355.58Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 84.58,
    y: 185.79,
    width: 236.57,
    height: 156.97,
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 199.6,
    cy: 225,
    r: 20.54,
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.7,221.88V220a3.38,3.38,0,0,1,3.38-3.38h3A3.38,3.38,0,0,1,204.5,220v1.92h2.19V220a5.58,5.58,0,0,0-5.57-5.57h-3a5.58,5.58,0,0,0-5.57,5.57v1.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.75,224.41V234.5a1.12,1.12,0,0,0,1.12,1.12h17.46a1.12,1.12,0,0,0,1.12-1.12V224.41a1.12,1.12,0,0,0-1.12-1.12H190.87A1.12,1.12,0,0,0,189.75,224.41Zm10.48,5.71v2H199v-2a1.21,1.21,0,0,1-.62-1,1.25,1.25,0,0,1,2.5,0A1.21,1.21,0,0,1,200.23,230.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128,
    y: 262.55,
    width: 23.58,
    height: 23.58,
    rx: 2.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.91,
    y: 262.52,
    width: 23.58,
    height: 23.58,
    rx: 2.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 187.81,
    y: 262.49,
    width: 23.58,
    height: 23.58,
    rx: 2.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 217.71,
    y: 262.45,
    width: 23.58,
    height: 23.58,
    rx: 2.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.61,
    y: 262.42,
    width: 23.58,
    height: 23.58,
    rx: 2.09,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.21,274.67c0-4.15,2.22-6.51,5.2-6.51s5.19,2.36,5.19,6.51-2.22,6.51-5.19,6.51S254.21,278.82,254.21,274.67Zm8.57,0c0-3.26-1.39-4.89-3.37-4.89s-3.38,1.63-3.38,4.89,1.38,4.89,3.38,4.89S262.78,277.92,262.78,274.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.53,274.51c0,4.34-2.46,6.67-6,6.67a6.15,6.15,0,0,1-3.17-.75L136,279a4.5,4.5,0,0,0,2.45.6c2.58,0,4.22-1.62,4.22-4.81v-.45A4.25,4.25,0,0,1,139,276c-2.53,0-4.35-1.51-4.35-3.85s2-4,4.49-4C142.6,268.16,144.53,270.45,144.53,274.51Zm-2.24-2.42c0-1.31-1-2.46-3-2.46a2.5,2.5,0,0,0-2.8,2.47c0,1.5,1.11,2.46,2.9,2.46S142.29,273.49,142.29,272.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.5,274.67c0-4.15,2.22-6.51,5.2-6.51s5.19,2.36,5.19,6.51-2.22,6.51-5.19,6.51S164.5,278.82,164.5,274.67Zm8.57,0c0-3.26-1.38-4.89-3.37-4.89s-3.38,1.63-3.38,4.89,1.38,4.89,3.38,4.89S173.07,277.93,173.07,274.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.2,279.45V281h-9.15V279.8l5.18-5c1.35-1.31,1.6-2.11,1.6-2.91,0-1.31-.92-2.11-2.71-2.11a4,4,0,0,0-3.25,1.38l-1.24-1.07a5.88,5.88,0,0,1,4.66-1.93c2.65,0,4.36,1.36,4.36,3.54,0,1.24-.36,2.35-2.09,4l-3.89,3.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231,268.3V281h-1.8V269.89h-2.88V268.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.23,256.79v.45h-3.47v-4.91h3.36v.45h-2.84v1.75h2.53V255h-2.53v1.82Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.73,255.1v2.14h-.5v-2.09a1,1,0,0,0-1.11-1.18,1.21,1.21,0,0,0-1.29,1.33v1.94h-.49v-3.69h.47v.68a1.55,1.55,0,0,1,1.4-.7A1.41,1.41,0,0,1,181.73,255.1Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185,257a1.17,1.17,0,0,1-.78.26,1,1,0,0,1-1.08-1.07V254h-.66v-.42h.66v-.8h.5v.8h1.12V254h-1.12v2.2c0,.44.22.67.63.67a.85.85,0,0,0,.55-.18Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,255.55h-3.08a1.37,1.37,0,0,0,1.45,1.28,1.46,1.46,0,0,0,1.13-.48l.28.32a2,2,0,0,1-3.36-1.27,1.77,1.77,0,0,1,1.8-1.87A1.75,1.75,0,0,1,189,255.4S189,255.49,189,255.55Zm-3.08-.37h2.61a1.31,1.31,0,0,0-2.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.87,253.53V254h-.12a1.19,1.19,0,0,0-1.24,1.36v1.88H190v-3.69h.48v.72A1.38,1.38,0,0,1,191.87,253.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,253.55l-1.84,4.13c-.31.72-.7.95-1.23.95a1.22,1.22,0,0,1-.89-.34l.23-.37a.88.88,0,0,0,.67.28c.33,0,.55-.15.76-.61l.16-.36L194,253.55h.52l1.38,3.13,1.39-3.13Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198,255.4a1.88,1.88,0,1,1,1.88,1.87A1.81,1.81,0,0,1,198,255.4Zm3.24,0a1.37,1.37,0,1,0-1.36,1.43A1.34,1.34,0,0,0,201.21,255.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.05,253.55v3.69h-.47v-.68a1.47,1.47,0,0,1-1.33.71,1.42,1.42,0,0,1-1.55-1.58v-2.14h.49v2.09a1,1,0,0,0,1.11,1.18,1.19,1.19,0,0,0,1.25-1.33v-1.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.3,253.53V254h-.12a1.19,1.19,0,0,0-1.24,1.36v1.88h-.5v-3.69h.48v.72A1.38,1.38,0,0,1,209.3,253.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.75,254.79a2.58,2.58,0,1,1,2.58,2.49A2.48,2.48,0,0,1,211.75,254.79Zm4.63,0a2.06,2.06,0,1,0-2,2A2,2,0,0,0,216.38,254.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.94,252.78h-1.72v-.45h4v.45h-1.73v4.46h-.52Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M225.85,254c0,1-.76,1.67-2,1.67h-1.31v1.55H222v-4.91h1.83C225.09,252.33,225.85,253,225.85,254Zm-.52,0c0-.79-.52-1.24-1.5-1.24h-1.3v2.45h1.3C224.81,255.23,225.33,254.79,225.33,254Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M180.15,298.89l.2-.39a2.41,2.41,0,0,0,1.62.59c.91,0,1.31-.38,1.31-.87,0-1.34-3-.52-3-2.33,0-.72.56-1.34,1.8-1.34a2.77,2.77,0,0,1,1.52.43l-.17.41a2.55,2.55,0,0,0-1.35-.4c-.89,0-1.29.4-1.29.89,0,1.34,3,.53,3,2.31,0,.73-.57,1.34-1.82,1.34A2.63,2.63,0,0,1,180.15,298.89Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188,297.8h-3.08a1.37,1.37,0,0,0,1.45,1.28,1.46,1.46,0,0,0,1.13-.48l.28.32a1.79,1.79,0,0,1-1.42.61,1.83,1.83,0,0,1-1.94-1.88,1.78,1.78,0,0,1,1.8-1.87,1.75,1.75,0,0,1,1.79,1.87S188,297.75,188,297.8Zm-3.08-.37h2.61a1.31,1.31,0,0,0-2.61,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.43,297.35v2.14h-.49V297.4a1,1,0,0,0-1.11-1.17,1.21,1.21,0,0,0-1.29,1.33v1.93H189v-3.68h.48v.68a1.55,1.55,0,0,1,1.4-.71A1.41,1.41,0,0,1,192.43,297.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.16,294.29v5.2h-.48v-.73a1.59,1.59,0,0,1-1.42.77,1.88,1.88,0,0,1,0-3.75,1.6,1.6,0,0,1,1.4.73v-2.22Zm-.49,3.36a1.37,1.37,0,1,0-1.37,1.43A1.35,1.35,0,0,0,196.67,297.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.16,297.21v2.28h-.48v-.57a1.4,1.4,0,0,1-1.27.61c-.83,0-1.34-.44-1.34-1.08s.36-1,1.42-1h1.17v-.22a.91.91,0,0,0-1-1,1.86,1.86,0,0,0-1.23.44l-.22-.37a2.29,2.29,0,0,1,1.49-.5A1.31,1.31,0,0,1,203.16,297.21Zm-.5,1.17v-.6H201.5c-.71,0-.94.28-.94.66s.34.69.93.69A1.17,1.17,0,0,0,202.66,298.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.93,295.81V299a1.61,1.61,0,0,1-1.84,1.84,2.61,2.61,0,0,1-1.72-.56l.25-.38a2.25,2.25,0,0,0,1.45.5c.94,0,1.36-.42,1.36-1.33v-.47a1.64,1.64,0,0,1-1.43.71,1.79,1.79,0,1,1,0-3.57,1.65,1.65,0,0,1,1.45.73v-.7Zm-.48,1.75a1.4,1.4,0,1,0-1.4,1.35A1.32,1.32,0,0,0,207.45,297.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.1,297.21v2.28h-.47v-.57a1.41,1.41,0,0,1-1.27.61c-.84,0-1.35-.44-1.35-1.08s.37-1,1.43-1h1.16v-.22c0-.63-.35-1-1-1a1.85,1.85,0,0,0-1.22.44l-.23-.37a2.32,2.32,0,0,1,1.5-.5A1.31,1.31,0,0,1,212.1,297.21Zm-.5,1.17v-.6h-1.15c-.72,0-.95.28-.95.66s.35.69.94.69A1.15,1.15,0,0,0,211.6,298.38Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.34,294.64a.37.37,0,0,1,.73,0,.37.37,0,0,1-.73,0Zm.11,1.17h.5v3.68h-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.72,297.35v2.14h-.49V297.4a1,1,0,0,0-1.11-1.17,1.21,1.21,0,0,0-1.29,1.33v1.93h-.49v-3.68h.47v.68a1.55,1.55,0,0,1,1.4-.71A1.41,1.41,0,0,1,218.72,297.35Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.46,324.49H171.73a8.31,8.31,0,0,1-8.3-8.31h0a8.31,8.31,0,0,1,8.3-8.31h55.73a8.31,8.31,0,0,1,8.31,8.31h0A8.31,8.31,0,0,1,227.46,324.49Z",
    style: {
      fill: "#fff",
      opacity: 0.4
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.86,315.76a2.84,2.84,0,0,1,3-2.87,2.78,2.78,0,0,1,2.13.88l-.52.5a2.07,2.07,0,0,0-1.58-.66,2.15,2.15,0,1,0,1.58,3.63l.52.5a2.79,2.79,0,0,1-2.14.88A2.83,2.83,0,0,1,177.86,315.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.53,315.76a3,3,0,1,1,3,2.86A2.85,2.85,0,0,1,183.53,315.76Zm5.15,0a2.18,2.18,0,1,0-2.17,2.15A2.1,2.1,0,0,0,188.68,315.76Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.52,313v5.6h-.66l-3.36-4.18v4.18h-.8V313h.66l3.36,4.17V313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.31,313.65h-1.92V313H201v.69H199.1v4.91h-.79Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.89,313h.8v5.6h-.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.19,313v5.6h-.66l-3.36-4.18v4.18h-.8V313H205l3.36,4.17V313Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.82,316.14V313h.8v3.15c0,1.24.57,1.8,1.58,1.8s1.58-.56,1.58-1.8V313h.78v3.18a2.37,2.37,0,1,1-4.74,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.26,317.86v.7H217.2V313h4v.69H218v1.72h2.8v.68H218v1.81Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.49,186.52C263.78,219.29,179.77,292.23,84.58,286.83V186.52Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.14,246.75V343.5H178.72c5.46-19.54,16.38-46.3,37.56-65.42C254.38,243.68,298.6,243.78,321.14,246.75Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-1"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "351.23 171.09 354.55 185.75 357.87 171.09 351.23 171.09",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "351.23 171.09 354.55 185.75 357.87 171.09 351.23 171.09",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.81,
    y: 129.58,
    width: 91.49,
    height: 44.76,
    rx: 8.59,
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 308.81,
    y: 129.58,
    width: 91.49,
    height: 44.76,
    rx: 8.59,
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M327.08,146v1.93h-.79V146l-2.22-3.64h.86l1.79,3,1.8-3h.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.13,145.82a2.21,2.21,0,1,1,2.21,2.17A2.11,2.11,0,0,1,329.13,145.82Zm3.63,0a1.43,1.43,0,1,0-2.85,0,1.43,1.43,0,1,0,2.85,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.55,143.7v4.24h-.72v-.64a1.72,1.72,0,0,1-1.44.69,1.67,1.67,0,0,1-1.83-1.85V143.7h.77v2.36c0,.83.42,1.24,1.15,1.24a1.24,1.24,0,0,0,1.31-1.4v-2.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.3,143.66v.75h-.18a1.26,1.26,0,0,0-1.33,1.43v2.11H340V143.7h.74v.72A1.61,1.61,0,0,1,342.3,143.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.11,145.14a3,3,0,1,1,3,2.87A2.84,2.84,0,0,1,345.11,145.14Zm5.15,0a2.18,2.18,0,1,0-2.17,2.15A2.1,2.1,0,0,0,350.26,145.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.32,143H351.4v-.69H356V143h-1.92v4.9h-.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.42,144.3c0,1.21-.88,1.95-2.34,1.95H357.7v1.69h-.8v-5.59h2.18C360.54,142.35,361.42,143.08,361.42,144.3Zm-.8,0c0-.8-.54-1.26-1.56-1.26H357.7v2.51h1.36C360.08,145.55,360.62,145.1,360.62,144.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.37,145.14a3,3,0,0,1,5.1-2l-.52.51a2.08,2.08,0,0,0-1.58-.67,2.15,2.15,0,1,0,0,4.3,2.08,2.08,0,0,0,1.58-.67l.52.51a3,3,0,0,1-5.1-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.93,145.82a2.21,2.21,0,1,1,2.21,2.17A2.11,2.11,0,0,1,369.93,145.82Zm3.63,0a1.43,1.43,0,1,0-2.85,0,1.43,1.43,0,1,0,2.85,0Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.4,142v5.93h-.73v-.67a1.8,1.8,0,0,1-1.51.72,2.17,2.17,0,0,1,0-4.33,1.83,1.83,0,0,1,1.48.68V142Zm-.76,3.81a1.43,1.43,0,1,0-1.42,1.5A1.39,1.39,0,0,0,378.64,145.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.67,146.08h-3.43a1.43,1.43,0,0,0,1.53,1.24,1.58,1.58,0,0,0,1.22-.51l.43.49a2.31,2.31,0,0,1-3.95-1.48,2.08,2.08,0,0,1,2.13-2.16,2,2,0,0,1,2.09,2.19A2,2,0,0,1,384.67,146.08Zm-3.43-.55H384a1.36,1.36,0,0,0-2.71,0Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M343,156.7c0,3.15-1.77,4.83-4.36,4.83a4.46,4.46,0,0,1-2.29-.54l.5-1a3.31,3.31,0,0,0,1.78.43c1.87,0,3.06-1.17,3.06-3.48v-.32a3.09,3.09,0,0,1-2.66,1.21,2.84,2.84,0,0,1-3.15-2.79,3,3,0,0,1,3.25-2.92C341.6,152.1,343,153.76,343,156.7ZM341.37,155c0-.95-.76-1.78-2.2-1.78a1.81,1.81,0,0,0-2,1.79c0,1.08.8,1.78,2.09,1.78A1.92,1.92,0,0,0,341.37,155Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.26,156.82c0-3,1.61-4.72,3.77-4.72s3.75,1.72,3.75,4.72-1.61,4.71-3.75,4.71S344.26,159.82,344.26,156.82Zm6.2,0c0-2.36-1-3.54-2.43-3.54s-2.45,1.18-2.45,3.54,1,3.54,2.45,3.54S350.46,159.18,350.46,156.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.49,160.28v1.15h-6.63v-.9l3.76-3.62c1-.95,1.15-1.53,1.15-2.11,0-.94-.67-1.52-2-1.52a2.87,2.87,0,0,0-2.35,1l-.9-.78a4.26,4.26,0,0,1,3.37-1.4c1.92,0,3.16,1,3.16,2.57a3.73,3.73,0,0,1-1.51,2.9l-2.82,2.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.43,152.21v9.22h-1.31v-8.07H360v-1.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.44,156.82c0-3,1.61-4.72,3.77-4.72s3.75,1.72,3.75,4.72-1.6,4.71-3.75,4.71S365.44,159.82,365.44,156.82Zm6.21,0c0-2.36-1-3.54-2.44-3.54s-2.45,1.18-2.45,3.54,1,3.54,2.45,3.54S371.65,159.18,371.65,156.82Z",
    style: {
      fill: "#263238"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M346.33,214.09a59.3,59.3,0,0,0,19.7,8.85l.07,0a2.59,2.59,0,0,0-1.49.42,2.65,2.65,0,0,0-1,1.13,1.1,1.1,0,0,0-.12.46c.16-2.1-.75-4.46-1.39-6.73-1.15-3.59-2.5-7.27-3.85-10.88l3.86-2.07c3.19,4.89,13.84,20.37,6.57,24.85a5.79,5.79,0,0,1-4.13.66,53.2,53.2,0,0,1-22.1-8.62c-.46-.32-.86-.6-1.4-1l5.3-7.09Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.21,213a19.79,19.79,0,0,1,9.63,3.91l-4,12.38S331.4,211.37,345.21,213Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,223.41a79.48,79.48,0,0,0,5.64,5.83l1.65-5.09,2.38-7.29a19.79,19.79,0,0,0-9.62-3.91C336.72,212,340.78,218.36,345.17,223.41Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M345.17,223.41a79.48,79.48,0,0,0,5.64,5.83l1.65-5.09a11.84,11.84,0,0,0-7.26-2.5A10.4,10.4,0,0,0,345.17,223.41Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302,194.69s-9.3,30.92,10.29,35.07S334,219.68,334,219.68,317.9,195.32,302,194.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.41,204.93a.2.2,0,0,1-.11,0,.23.23,0,0,1-.1-.32,3.93,3.93,0,0,1,2.88-2,.26.26,0,0,1,.25.23.24.24,0,0,1-.22.26,3.48,3.48,0,0,0-2.49,1.76A.22.22,0,0,1,297.41,204.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.21,208.77a14.91,14.91,0,0,1-.81,3.53,2,2,0,0,0,2.05,0Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.32,207.42c.21.55.68.88,1,.74s.5-.69.29-1.24-.68-.88-1-.74S298.12,206.87,298.32,207.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.77,206.15l-1.37,0S298.38,206.91,298.77,206.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.23,212.61a1,1,0,0,1-.14.25c-.09.17-.19.33-.29.5a9.54,9.54,0,0,1-2.3,2.75c-3,2.39-5.61,3.11-7.88,2.42l-.33-.11h0c-3.37-1.37-6-5.4-8.09-10.73a21.18,21.18,0,0,1-1.73-6.58s0-.08,0-.1,0-.18,0-.26a7.84,7.84,0,0,1,3.16-6.77,15.18,15.18,0,0,1,2.9-1.79C313.52,187.32,323.24,203.18,318.23,212.61Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.8,213.36a9.54,9.54,0,0,1-2.3,2.75c-3,2.39-5.61,3.11-7.88,2.42a11,11,0,0,0,5.69-3.45A5.68,5.68,0,0,1,317.8,213.36Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.42,201.05s2.79,7.34,10.94,7.21c0,0,6.36,6,10.65,4.09,5.85-2.59,7.05-13.23,1.09-20.66C312.36,182.05,295.48,189,297.42,201.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304,207.84c-.52-1.11-.51-3.38,1.32-3.94s5,3.33,1.06,6.37C305.82,210.71,305.08,210.14,304,207.84Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.19,187.69s-7.56,1.49-10,6c-2.86,5.24-3,9.3,4.6,12,0,0,9.61-9,13.75-10a44.34,44.34,0,0,1,7.35-1.18C319.13,186.52,309.24,184.38,306.19,187.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.52,216.3s5.2,3.6,6.55,9.54l16.21-9.46s-12.69-2.89-14.87-7.8C321.41,208.58,312.93,209.63,313.52,216.3Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.62,255.25s-21-20.63-23.26-27.11c0,0,8.83-13.75,26.48-14.33s29.66,33,29.66,33Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5,246.82l-32.87,8.44s-4.58-4.51-9.7-10c-1.58-1.71-3.23-3.51-4.82-5.29-4.17-4.73-7.85-9.35-8.74-11.86,0,0,8.82-13.75,26.47-14.33S362.5,246.82,362.5,246.82Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,204.74s3.07,10.2,13.85,13.58,8.07,14.39,18.52,13.09c5.56-.69,10.32-12-6.73-22-9.94-5.81-6.08-24.91-27.18-23.12C308.44,186.3,312.82,199.39,310,204.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320.47,410.73l-5-1.14c.75-25,4.36-55.23,7.55-77.94.5-3.56,1-6.92,1.46-10.06.23-1.49.44-2.92.65-4.3,1-6.81,1.92-12.19,2.47-15.52.41-2.43.64-3.76.64-3.76l18,4.39-1.29,4.54-4.25,15-.48,1.71-2.82,9.89-4.78,16.83C332.92,375.78,320.47,410.73,320.47,410.73Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.27,406.55l-5.12-.26c-3.9-26.88-5.54-60.5-6.25-83.87-.1-3.62-.19-7-.26-10.08,0-.15,0-.3,0-.45-.13-6.09-.19-10.93-.22-14,0-2.4,0-3.71,0-3.71l18.47,1.21-.79,7.7-1.16,11.3-.23,2.22-.8,7.7L364.75,345C369.47,370,363.27,406.55,363.27,406.55Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.19,405.55c0-.64-7.9-.14-7.9-.14s-4.85,4.93-9.56,6-2.07,3.94,3.19,3.94h13C367.68,415.39,365.34,412.2,365.19,405.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.45,407.24a.75.75,0,0,1-.19-.84.87.87,0,0,1,.42-.53,3.28,3.28,0,0,1,1.77-.2c-.64-.34-1.2-.75-1.23-1.17,0-.27.16-.49.52-.66a1.21,1.21,0,0,1,1,0c1.07.45,1.73,2.29,1.76,2.36a.21.21,0,0,1,0,.16l0,.05h0a.18.18,0,0,1-.07.05,9.75,9.75,0,0,1-3.26,1A1.06,1.06,0,0,1,352.45,407.24Zm.44-1a.46.46,0,0,0-.23.27c-.08.31,0,.39,0,.42.38.31,1.82-.13,3-.62A5.07,5.07,0,0,0,352.89,406.23Zm1-2c-.11,0-.29.15-.28.26,0,.35,1.15,1,2.31,1.41a3.47,3.47,0,0,0-1.35-1.69.74.74,0,0,0-.32-.07A.8.8,0,0,0,353.92,404.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323,405.55c0-.64-7.89-.14-7.89-.14s-4.85,4.93-9.56,6-2.08,3.94,3.18,3.94h13C325.5,415.39,323.17,412.2,323,405.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,407.24a.77.77,0,0,1-.19-.84.87.87,0,0,1,.42-.53,3.29,3.29,0,0,1,1.77-.2c-.64-.34-1.2-.75-1.22-1.17q0-.4.51-.66a1.21,1.21,0,0,1,1,0c1.07.45,1.73,2.29,1.76,2.36a.18.18,0,0,1,0,.16s0,0,0,.05h0l-.07.05a9.9,9.9,0,0,1-3.27,1A1.08,1.08,0,0,1,310.27,407.24Zm.44-1a.44.44,0,0,0-.22.27c-.08.31,0,.39.05.42.37.31,1.81-.13,3-.62A5.07,5.07,0,0,0,310.71,406.23Zm1-2c-.11,0-.29.15-.28.26,0,.35,1.15,1,2.32,1.41a3.49,3.49,0,0,0-1.36-1.69.71.71,0,0,0-.32-.07A.8.8,0,0,0,311.74,404.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,305.53l4.26-30v-20.3c11.23-8.44,32.88-8.44,32.88-8.44s16.63,23.07,8.55,61l-20.88,3-1.33-7.08-2.62,7.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.36,305.53l4.26-30v-20.3c11.23-8.44,32.88-8.44,32.88-8.44s16.63,23.07,8.55,61l-20.88,3-1.33-7.08-2.62,7.08Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.84,303.82l4-12.49s4.22-1.28,9.64-9.66C362.5,281.67,361.56,295.93,348.84,303.82Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.94,261l9.37-.89a21.08,21.08,0,0,1,1.5,11.12l-6,3.61-4.35-3.09S340.32,263.82,339.94,261Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.5,258.71a47.53,47.53,0,0,1,2.77,9.59l3.32,1.41,1.79-2.23s-1.21-6.53-3.26-9.73Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "324.97 303.82 347.13 310.32 345.74 313.3 324.69 306.82 324.97 303.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "349.31 309.89 349.68 312.63 371.41 309.89 371.74 306.44 349.31 309.89",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.87,251a77.27,77.27,0,0,1,10.75-1.05l-1.34-2.21a61.47,61.47,0,0,0-10.48.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.94,253.72c-2.87,1.24-4.52,2.17-4.52,2.17l0,2.73q2.42-1.22,4.85-2.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.32,256a87.57,87.57,0,0,1,17.21-4.79l-1-2.66a75.47,75.47,0,0,0-16.62,4.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.24,263.81l-5.68-2.28-1,5.36s5.12,3.1,7.26-.59Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "266.74 261.86 264.92 266 268.6 266.89 269.56 261.53 266.74 261.86",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.41,206.2l-.67-6.08-5.18,1.68s-.32,6,3.95,6.12Z",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.11 197.79 355.6 198.15 356.56 201.8 361.74 200.12 360.11 197.79",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.93,245.29c-1.58-1.71-3.23-3.51-4.82-5.29-.61-3.72-1-7-1-7A14.44,14.44,0,0,1,319.93,245.29Z",
    style: {
      isolation: "isolate",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.69,231.28a112,112,0,0,1-10.29,26.5c-4.5,8.55-21.61,9.58-30.21,9.8l-.4-4.36c5.18-1.22,21.28-4.43,23.48-9.1a170.39,170.39,0,0,0,8.84-25l8.58,2.14Z",
    style: {
      fill: "#dc897c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.79,223.74c-4.89,3.2-7.51,11.52-8.34,15.59l10.16,7.48,5.13-5C318.82,230.33,311.65,222.53,309.79,223.74Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.79,223.74c-4.89,3.2-7.51,11.52-8.34,15.59l10.16,7.48,5.13-5C318.82,230.33,311.65,222.53,309.79,223.74Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,208.15l-7.26.78a.74.74,0,0,1-.76-.78l-.44-15.37a.9.9,0,0,1,.72-.94l7.25-.77a.73.73,0,0,1,.76.78l.44,15.37A.89.89,0,0,1,359.39,208.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.39,208.15l-7.26.78a.74.74,0,0,1-.76-.78l-.44-15.37a.9.9,0,0,1,.72-.94l7.25-.77a.73.73,0,0,1,.76.78l.44,15.37A.89.89,0,0,1,359.39,208.15Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75,208.22l-7.25.77a.73.73,0,0,1-.77-.77l-.43-15.38a.87.87,0,0,1,.71-.93l7.25-.77a.73.73,0,0,1,.76.77l.44,15.38A.87.87,0,0,1,358.75,208.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.75,208.22l-7.25.77a.73.73,0,0,1-.77-.77l-.43-15.38a.87.87,0,0,1,.71-.93l7.25-.77a.73.73,0,0,1,.76.77l.44,15.38A.87.87,0,0,1,358.75,208.22Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.27,191.44l-1.9.2-.24.59-2.94.31-.27-.53-1.9.2a.58.58,0,0,0-.46.61l.43,15.37a.47.47,0,0,0,.5.5l7.25-.77a.57.57,0,0,0,.46-.6l-.43-15.38A.48.48,0,0,0,358.27,191.44Z",
    style: {
      fill: "#AB1EDA"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.3,197l-5.33.57a.47.47,0,0,1-.49-.49l0-1.48a.56.56,0,0,1,.45-.6l5.34-.57a.47.47,0,0,1,.48.5l.05,1.48A.56.56,0,0,1,357.3,197Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnterOtp);
export default __webpack_public_path__ + "static/media/enter_otp.33b6fa16c33c9fd4931072dc560fbd92.svg";
export { ForwardRef as ReactComponent };